import { api } from "./client";

/** Las lecciones que el alumno ya ha hecho, con sus ejercicios de emparejar ronda a ronda.
 *  De aquí come la Extracción: se repasa lo que se ha estudiado, no el curso entero. */
export const getRepaso = async (params) => (await api.get("/mundo/repaso", { params })).data;

/** Qué se ha ganado esta cuenta: `{ sitios, poderes }`.
 *  La regla y los números viven en el servidor: aquí sólo se pregunta.
 *
 *  SON DOS LISTAS Y NO UNA DESDE EL 21 DE OCTUBRE DE 2026 (M21). Los sitios los lee
 *  `lib/puertas.mjs` —el plano, el suelo, el viaje rápido— y los poderes `lib/poderes.mjs`.
 *  Mezclados, el fogonazo habría salido en el plano como un lugar cerrado al que volar.
 *  Y viajan juntos porque se cuentan con la misma consulta: dos rutas serían contar dos
 *  veces lo mismo en la misma entrada al mundo. */
export const getGanado = async () => (await api.get("/mundo/puertas")).data;

/** Lo clasificable de las lecciones que esta cuenta ha terminado, para los niveles de la pesca
 *  (G16): `{ estudiadas, familias: [...], pendientes: [...] }`.
 *
 *  LOS DOS NÚMEROS LOS PONE QUIEN PINTA, que es la regla de la casa: cuántas palabras necesita
 *  una cesta y cuánto mide una palabra en una burbuja no lo puede saber el servidor. Los dice
 *  `lib/nivelesDePesca.mjs`, que es quien ha medido las dos cosas. */
export const getClasificaciones = async (porClaseMin, piezaMax) =>
  (await api.get("/mundo/clasificaciones",
    { params: { por_clase_min: porClaseMin, pieza_max: piezaMax } })).data;

/** Lo que esta cuenta ha ganado en los minijuegos del mundo, y sus récords:
 *  `{ juegos: { juego: {veces, marcas} }, records: { juego: número } }`. */
export const getVictorias = async () => (await api.get("/mundo/victorias")).data;

/** Una racha de la guardia del Ojo. El servidor se queda la mejor y contesta la que queda.
 *  ES EL ÚNICO SITIO DONDE ESTA CASA MANDA UN NÚMERO, y se admite porque no desbloquea nada:
 *  el porqué entero y la condición de que deje de valer, en `domain/victorias.CON_RECORD`. */
export const postRecord = async (juego, racha) =>
  (await api.post("/mundo/record", { juego, racha: Math.max(0, Math.floor(racha) || 0) })).data;

/** Una victoria más. `marca` es QUÉ se ganó, para los juegos que cuentan cosas distintas.
 *  NUNCA se manda un número de victorias: lo suma el servidor, o la cuenta la pondría el
 *  navegador y subir de nivel sería escribir en una consola. */
export const postVictoria = async (juego, marca = "") =>
  (await api.post("/mundo/victorias", { juego, marca: marca ? String(marca) : "" })).data;

/** Sube lo que había en el `localStorage` y recoge lo juntado. Se puede llamar mil veces:
 *  `domain/victorias.junta` se queda lo mayor de cada juego y la unión de las marcas. */
export const juntaVictorias = async (juegos) =>
  (await api.post("/mundo/victorias/junta", { juegos: juegos || {} })).data;
